/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Signedcontractfileid4Inputs */

const en__field_signedcontractfileid4 = /** @type {(inputs: _Field_Signedcontractfileid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed Contract`)
};

const de__field_signedcontractfileid4 = /** @type {(inputs: _Field_Signedcontractfileid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterschriebener Vertrag`)
};

/**
* | output |
* | --- |
* | "Signed Contract" |
*
* @param {_Field_Signedcontractfileid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_signedcontractfileid4 = /** @type {((inputs?: _Field_Signedcontractfileid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Signedcontractfileid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_signedcontractfileid4(inputs)
	return de__field_signedcontractfileid4(inputs)
});
export { _field_signedcontractfileid4 as "_field_signedContractFileID" }